import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { ExpiringContractsServiceData, PastExpiringContractsService } from "../../services/contractsKpi/expiringContracts.service";
import { ContractDetail, ExpiringContractsDetailServiceData, PastExpiringContractsDetailService } from "../../services/contractsKpi/expiringContractsDetail.service";
import { DateColumnDefinition, EmailColumnDefinition, NumberColumnDefinition, PhoneNumberColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";
import { ContractsDetailData } from "./contractsDetailData";

@Component({
    selector: 'past-expiring-contracts-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class PastExpiringContractsKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<PastExpiringContractsService, ExpiringContractsServiceData, ExpiringContractsServiceData, PastExpiringContractsDetailService, ExpiringContractsDetailServiceData, ContractsDetailData>
    implements OnDestroy {
    public getClassName() { return "PastExpiringContractsKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: PastExpiringContractsService, detailService: PastExpiringContractsDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: ExpiringContractsServiceData): ExpiringContractsServiceData {
        this.setWarn(data.consultant + data.office > 0);
        return data;
    }

    protected getDefaultSummaryData(): ExpiringContractsServiceData {
        this.setWarn(false);
        let data = new ExpiringContractsServiceData();
        data.consultant = 0;
        data.office = 0;
        data.consultantExpiredBeforeRange = 0;
        data.officeExpiredBeforeRange = 0;
        data.updateTimestamp = new Date();
        return data;
    }

    protected extractUpdateTime(data: ExpiringContractsServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: ExpiringContractsDetailServiceData, args: any): ContractsDetailData {

        let end = moment().subtract(1, 'day');
        let begin = moment(end).subtract(15, 'day');
        if (data.contracts) {
            if (args && args.filter && args.filter.consultant) {
                let columnDefinitions = [
                    new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY"), true),
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Trabajador"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                    new NumberColumnDefinition("Tp. Contrato"),
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Unidad", null, true),
                    new TextColumnDefinition("Nombre interlocutor", null, true),
                    new PhoneNumberColumnDefinition("Teléfono interlocutor"),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.contracts).find(x => x.nif == consultantNif) || { name: null }).name;
                        columnDefinitions[7].filterTerm = [consultantName];
                    }
                    if (args.filter.date) columnDefinitions[0].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let contract of data.contracts) {
                    if (contract.nif.toUpperCase() == consultantNif) {
                        tabledata.push([
                            contract.endDate,
                            contract.clientFiscalName,
                            contract.workername,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.laboralContractId,
                            contract.name,
                            contract.unitName,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                    else {
                        tabledata2.push([
                            contract.endDate,
                            contract.clientFiscalName,
                            contract.workername,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.laboralContractId,
                            contract.name,
                            contract.unitName,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ContractsDetailData(columnDefinitions, arrayOrdenado);
            } else {
                let columnDefinitions = [
                    new TextColumnDefinition("Consultor", null, true),
                    new TextColumnDefinition("Unidad", null, true),
                    new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY"), true),
                    new TextColumnDefinition("Cliente", null, true),
                    new TextColumnDefinition("Trabajador"),
                    new PhoneNumberColumnDefinition("Teléfono"),
                    new EmailColumnDefinition("Email"),
                    new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
                    new NumberColumnDefinition("Tp. Contrato"),
                    new TextColumnDefinition("Nombre interlocutor", null, true),
                    new PhoneNumberColumnDefinition("Teléfono interlocutor"),
                ];

                let consultantNif = this.impersonationService.getNifSafe().toUpperCase();

                if (args && args.filter) {
                    if (args.filter.consultant) {
                        let consultantName = (this.extractConsultants(data.contracts).find(x => x.nif == consultantNif) || { name: null }).name;
                        columnDefinitions[0].filterTerm = [consultantName];
                    }
                    if (args.filter.date) columnDefinitions[2].filterTerm = [args.filter.date.format("DD/MM/YYYY")];
                }

                let tabledata2 = [];
                let tabledata = [];

                for (let contract of data.contracts) {
                    if (contract.nif.toUpperCase() == consultantNif) {
                        tabledata.push([
                            contract.name,
                            contract.unitName,
                            contract.endDate,
                            contract.clientFiscalName,
                            contract.workername,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.laboralContractId,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                    else {
                        tabledata2.push([
                            contract.name,
                            contract.unitName,
                            contract.endDate,
                            contract.clientFiscalName,
                            contract.workername,
                            contract.workerPhone,
                            contract.workerEmail,
                            contract.beginDate,
                            contract.laboralContractId,
                            contract.contactName,
                            contract.contactPhone,
                        ]);
                    }
                }
                let arrayOrdenado = tabledata.concat(tabledata2);
                return new ContractsDetailData(columnDefinitions, arrayOrdenado);
            }
        }
        else return this.getDefaultDetailData();
    }

    private extractConsultants(data: ContractDetail[]): { nif: string, name: string }[] {
        let nifs: { nif: string, name: string }[] = [];

        if (data) {
            data.forEach(x => {
                if (!nifs.find(y => x.nif.toUpperCase() == y.nif)) nifs.push({ nif: x.nif.toUpperCase(), name: x.name });
            })
        }

        return nifs;
    }

    protected getDefaultDetailData(): ContractsDetailData {
        let columnDefinitions = [
            new TextColumnDefinition("Consultor", null, true),
            new TextColumnDefinition("Unidad"),
            new DateColumnDefinition("Fecha fin", (data) => moment(data).format("DD/MM/YYYY")),
            new TextColumnDefinition("Cliente"),
            new TextColumnDefinition("Trabajador"),
            new PhoneNumberColumnDefinition("Teléfono"),
            new EmailColumnDefinition("Email"),
            new DateColumnDefinition("Fecha inicio", (data) => moment(data).format("DD/MM/YYYY")),
            new NumberColumnDefinition("Tp. Contrato"),
            new TextColumnDefinition("Nombre interlocutor", null, true),
            new PhoneNumberColumnDefinition("Teléfono interlocutor"),
        ];

        return new ContractsDetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }

    public mergeFilter(filter: any) {
        let detailProcessingArgs = this.detailProcessingArgs || {};
        detailProcessingArgs.filter = detailProcessingArgs.filter || {};
        detailProcessingArgs.filter = { ...detailProcessingArgs.filter, ...filter };
        this.detailProcessingArgs = detailProcessingArgs;
    }
}
